import { Injectable } from '@angular/core';
import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';
import { ExperienceCategory, ExperienceCategoryGroup, GetExperienceListingsRequest, UpdateExperienceListingStatusRequest } from '../../models';

@Injectable()
export class ListingReviewService {

	constructor(private readonly apiHttp: ApiHttp) {}

	/** Maps API `ExperienceCategories` payload items to `ExperienceCategory`. */
	mapExperienceCategoriesFromApi(apiItems: any[] | null | undefined): ExperienceCategory[] {
		return (apiItems ?? []).map((item: any): ExperienceCategory => ({
			id: item.Id,
			createdAt: item.CreatedAt,
			name: item.Name,
			imageUrl: item.ImageUrl ?? null,
			isActive: item.IsActive,
			sortOrder: item.SortOrder,
			parentCategoryId: item.ParentCategoryId ?? null
		}));
	}

	/** Groups flat categories into parent headers with child options (UI selects). */
	groupExperienceCategories(categories: ExperienceCategory[]): ExperienceCategoryGroup[] {
		const parents = categories.filter(c => c.parentCategoryId === null);
		return parents.map(parent => ({
			parent,
			children: categories.filter(c => c.parentCategoryId === parent.id)
		}));
	}

	getExperienceCategories(messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/ExperienceCategory/GetExperienceCategories', null, messageService);
	}

	upsertExperienceListing(request: object, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminExperienceListing/UpsertExperienceListing', request, messageService);
	}

	getExperienceListings(request: GetExperienceListingsRequest = {}, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminExperienceListing/GetExperienceListings', request, messageService);
	}

	getExperienceListingForEdit(
		request: { listingId: number; tourOperatorId: number },
		messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminExperienceListing/GetExperienceListingForEdit', {
			ListingId: request.listingId,
			TourOperatorId: request.tourOperatorId
		}, messageService);
	}

	updateExperienceListingStatus(
		request: UpdateExperienceListingStatusRequest,
		messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminExperienceListing/UpdateExperienceListingStatus', request, messageService);
	}
}
